import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=a5a87aaa&scoped=true"
import script from "./ProductHeader.vue?vue&type=script&lang=js"
export * from "./ProductHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&id=a5a87aaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a87aaa",
  null
  
)

export default component.exports